import React, { useEffect, useState } from 'react';
import useContentfulCalculators from '../contentfulCalculators'; // Corrected path
import Container from './Container';

const MortgageCalculatorComponent = () => {
    const calculators = useContentfulCalculators();
    const [filteredCalculator, setFilteredCalculator] = useState(null);
    const [result, setResult] = useState({ monthlyPayments: null, totalMortgageCost: null });
    const [showResults, setShowResults] = useState(false);

    useEffect(() => {
        const ukMortgageCalculator = calculators.find(calculator => calculator.fields.title === 'UK Mortgage Calculator');
        if (ukMortgageCalculator) {
            setFilteredCalculator(ukMortgageCalculator);
        }
    }, [calculators]);

    useEffect(() => {
        if (filteredCalculator) {
            const handleSubmit = (event) => {
                event.preventDefault();

                const mortgageTotalVal = event.target.balance.value;
                const mortgageTotalFormat = mortgageTotalVal.replace(/,/g, "").trim();
                const mortgageTotal = parseInt(mortgageTotalFormat);
                const mortgageInterest = parseFloat(event.target.rate.value);
                const mortgageLengthVal = event.target.term.value;
                const mortgageLength = parseInt(mortgageLengthVal.replace(/,/g, "").trim());
                const paymentPeriods = 12;

                const N = mortgageLength * paymentPeriods;
                const I = (mortgageInterest / 100) / paymentPeriods;
                const v = Math.pow((1 + I), N);
                const t = (I * v) / (v - 1);

                const monthlyPayments = mortgageTotal * t;
                const totalMortgageCost = monthlyPayments * N;

                setResult({
                    monthlyPayments: monthlyPayments.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    totalMortgageCost: totalMortgageCost.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                });

                setShowResults(true);
            };

            document.querySelector('.uk-mortgage').addEventListener('submit', handleSubmit);

            return () => {
                document.querySelector('.uk-mortgage').removeEventListener('submit', handleSubmit);
            };
        }
    }, [filteredCalculator]);

    if (!filteredCalculator) {
        return <div>Loading...</div>;
    }

    return (
        <Container>
            <div id={`calculator-${filteredCalculator.sys.id}`}>
                <div dangerouslySetInnerHTML={{ __html: filteredCalculator.fields.htmlCode }} />
            </div>
            {showResults && (
                <div id="mortgageResult" className="w-full max-w-lg mx-auto grid place-items-center pb-16">
                    <h2 className="text-xl font-bold text-center">Results</h2>
                    <p className="text-center">Here is a breakdown of your mortgage, including monthly repayments and total mortgage cost.</p>
                    <div id="mortgage02Results" className="mt-5">
                        <h4 className="text-center">Total cost: <strong id="mortgageTotalEsti" className="font-bold">£ {result.totalMortgageCost}</strong></h4>
                        <h4 className="text-center">Monthly payments: <strong id="monthlyPaymentsEsti" className="font-bold">£ {result.monthlyPayments}</strong></h4>
                    </div>
                    <div className="mt-5 text-center">
                        <small>This is an estimation of your total mortgage and monthly mortgage payments based on the information you have provided. This is not a quote and should not be considered financial advice.</small>
                    </div>
                </div>
            )}
        </Container>
    );
};

export default MortgageCalculatorComponent;